exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left { float: left; width: 52%; padding-right: 56px; }\n.right { float: right; width: 48%; text-align: left;}\n.center {}\n.details { border: 4px dashed #d8d8d8; width: 100%; padding: 58px 0 48px 0; text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/loading/loading.component.css
// module id = ../../../../../src/app/shared/loading/loading.component.css
// module chunks = main